import { render, staticRenderFns } from "./MyCases.vue?vue&type=template&id=31150cec&scoped=true&"
import script from "./MyCases.vue?vue&type=script&lang=ts&"
export * from "./MyCases.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31150cec",
  null
  
)

export default component.exports